import React, { useState } from 'react';
import { Input } from 'antd';
import { useQueryClient } from 'react-query';
import Modal from '../../../components/Modal';
import { useReturn } from '../../../core/modules/book/hooks/useReturn.query';
import { IBook } from '../../../section/Common/types/types';
import showNotification from '../../../section/Common/utils/showNotification';
import { useActions } from '../../../context/Actions.context';

const { TextArea } = Input;

interface IProps {
  book: IBook | Record<string, string | number>;
  modal: boolean;
  toggleModal: Function;
  id: string;
}

const ReturnTitles: React.FC<IProps> = ({ book, modal, toggleModal, id }) => {
  const { source, isActionLoading, setActionLoading } = useActions();
  const queryClient = useQueryClient();
  const book_ids = book.ASIN ? book.ASIN : book['Fiction Id'];
  const titleForNotification = typeof book?.Title === 'string' ? book.Title : undefined;
  const [notes, setNotes] = useState<string>('');

  const { mutateAsync } = useReturn({ book_ids, tabId: id, source: source['source'] });

  const handleClose = () => {
    setNotes('');
    toggleModal();
  };

  const onSend = () => {
    setActionLoading(true);

    const body = {
      ...(notes.trim() && { notes: notes.trim() })
    };

    const promise = mutateAsync(body);

    showNotification(
      promise,
      'The Title was successfully returned.',
      'The Title has not been returned.',
      titleForNotification
    );

    promise.then(() => queryClient.refetchQueries(`get-row-count${id}`));
    promise.then(() => queryClient.refetchQueries(`get-${id}`));
    promise.finally(() => setActionLoading(false));

    handleClose();
  };

  return (
    <Modal
      okText={'Return Title'}
      title='Return Title'
      visible={modal}
      onOk={onSend}
      confirmLoading={isActionLoading}
      onCancel={handleClose}
    >
      <div>
        <span>
          Help yourself and others understand why you&apos;re returning this. Leave a note, or skip and
          continue.
        </span>
        <br />
        <br />
        <TextArea
          placeholder='Add your notes here...'
          maxLength={400}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          rows={4}
        />

        <div style={{ textAlign: 'right', fontSize: 12, marginTop: 4 }}>
          {notes.length} / 400
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(ReturnTitles);